module.exports = {
  template: require('./bulk-transfers-list-container.pug')()
  controller: require('./bulk-transfers-list-container.ctrl')
}
